import React from 'react';
import './IconBadge.less';

export const IconBadgeColors = {
	normal: 'normal',
	dark: 'dark',
	primary: 'primary'
}

const IconBadgeColorClasses = {
	[IconBadgeColors.normal]: 'icon-badge--normal',
	[IconBadgeColors.dark]: 'icon-badge--dark',
	[IconBadgeColors.primary]: 'icon-badge--primary'
}

export const IconBadge = ({icon, isBig, color = IconBadgeColors.normal}) => {
	return (
		<span
			className={`icon-badge ${
				IconBadgeColorClasses[color]
			} ${
				isBig ? 'icon-badge--big' : ''
			}`}
			dangerouslySetInnerHTML={{__html: icon}}
		></span>
	);
};
